<template>
	<div id="preview">

		<PreviewStep  v-bind:step="currentStep"/>

		<ShowEditSlides v-bind:isInPreview="true"
						v-on:showText="showText($event)"
						v-on:reloadShow="reloadShow"
						v-on:nextStep="nextStep"
						v-on:backStep="backStep"
						v-on:thisStep="thisStep($event)"
						v-bind:show="show"
						v-bind:currentStepIndex="currentStepIndex"/>

	</div>
</template>

<script>
	import isLoggedIn from '@/services/IsLoggedIn.js';
	import PreviewStep from '@/components/preview/PreviewStep.vue';
	import ShowEditSlides from '@/components/show_edit/ShowEditSlides';
	import Show from '@/services/Show';
	import {EventBus} from '@/services/EventBus.js';

	export default {
		name: "Preview",
		components: {
			PreviewStep,
			ShowEditSlides,
		},
		data() {
			return {
				show: {},
				step: {},
				currentStep: {},
				currentStepIndex: 0,
				currentShowId: ''
			}
		},
		methods: {
			showText(step) {
				this.step = step;
			},
			hideText() {
				this.step = {};
			},
			async setShow() {
				let show = await Show.get(this.$route.params.id);

				let steps = show.steps;
				show.steps = [];

				for(let stepId in show.step_order) {

					let currentStep = steps.find(step => step.id === show.step_order[stepId]);
					if(!currentStep) {
						show.step_order = show.step_order.filter(stepOrder => stepOrder !== show.step_order[stepId]);
						await  Show.put(show);
					} else {
						show.steps.push(currentStep);
					}
				}

				this.show = show;

				this.setStep();
			},
			async reloadShow() {
				this.setShow();
			},
			async nextStep() {

				if(this.show.steps.length -1 === this.currentStepIndex) {
					this.currentStepIndex = 0;
				} else {
					this.currentStepIndex += 1;
				}

				this.setStep();
			},
			async backStep() {
				if(this.currentStepIndex === 0) {
					this.currentStepIndex = this.show.steps.length -1;
				} else {
					this.currentStepIndex -= 1;
				}

				this.setStep();
			},
			thisStep(index) {
				this.currentStepIndex = index;
				this.setStep();
			},
			setStep() {
				this.currentStep = this.show.steps[this.currentStepIndex];
			}
		},
		mounted() {
			this.currentShowId = '';
		},
		async created() {
			(await isLoggedIn() === false) ? this.$router.push('/login') : '';
			await this.setShow();

			EventBus.$emit('onCurrentShow', this.show.id);
			EventBus.$emit('onSelectedMenuItem', 'Vorschau');
		}
	}
</script>

<style scoped>
	#preview {
		height: 100%;
		display: flex;
		flex-direction: column;
	}
</style>